import { useEffect } from 'react'
import { PolicyPage, PageShell } from './PolicyPage'
export default function ReviewsPolicy() {
  useEffect(() => { document.title = 'Reviews Policy — SYNINN' }, [])
  return <PolicyPage title="Reviews & Ratings Policy" subtitle="How reviews work on SYNINN" sections={[
    { heading: 'Who can review', text: 'Only customers who have completed a confirmed booking at a restaurant can leave a review. This ensures all reviews are from genuine diners.' },
    { heading: 'Review guidelines', items: ['Be honest and constructive', 'No offensive or abusive language', 'One review per restaurant per customer'] },
    { heading: 'Moderation', text: 'SYNINN reserves the right to remove reviews that violate our guidelines. Flagged reviews are reviewed within 48 hours.' },
    { heading: 'Loyalty points', text: 'Writing a review earns you 2 loyalty points.' },
  ]} />
}